import React from 'react';
import { MdOutlineSatelliteAlt } from 'react-icons/md';
import { useSelector } from 'react-redux';

import { Top as TopUI, TopNotificationCount, TopStatusValue } from '@/components/ui/dashboard/Top';

const Top = ({ robot }) => {
  const robotStatus = useSelector((state) => state.robotStatus[robot.id]);

  return (
    <TopUI agentType={robot.model.agentType} owned={robot.isOwned} robotId={robot.id}>
      <TopStatusValue Icon={MdOutlineSatelliteAlt} value={robotStatus?.sats} style={{ gap: 4 }} />
      <TopNotificationCount robotId={robot.id} />
    </TopUI>
  );
};

export default Top;
